import { useMemo } from 'react'
import { useInMemoryPlaybackLocationContext } from '@mote/recipes'
import { useMoteConversationContext } from './MoteConversationContext'

export interface PlaybackLocation {
  type: 'inMemory' | 'remote'
  url: string
}

export function useMotePlaybackLocation(): PlaybackLocation {
  const inMemoryBlobContext = useInMemoryPlaybackLocationContext()
  const moteConversationContext = useMoteConversationContext()

  const inMemoryUrl = inMemoryBlobContext.getPlaybackUrl()
  const remoteUrl = moteConversationContext.hasData
    ? moteConversationContext.getMoteStatus().playbackLocation
    : ''

  return useMemo(() => {
    switch (true) {
      case Boolean(remoteUrl):
        return { type: 'remote' as const, url: remoteUrl }
      case Boolean(inMemoryUrl):
        return { type: 'inMemory' as const, url: inMemoryUrl }
      default:
        return { type: 'remote' as const, url: remoteUrl }
    }
  }, [inMemoryUrl, remoteUrl])
}
